import {JSEncrypt} from "jsencrypt";
import { getEnv } from './EnvHelper';

var key = getEnv("REACT_APP_RSA_ENCRYPTION_PUBLIC_KEY");
const JS_ENCRYPT = new JSEncrypt();
const PADDING_LENGTH = 11;
const MAX_LENGTH = 256;
const MAX_LENGTH_WITHOUT_PADDING = MAX_LENGTH - PADDING_LENGTH;
const DELIMITER = "$#$";
//For local testing add value here. DO NOT COMMIT PRIVATE KEY
let encryption_private_key = "";

(() => {
  // console.log("Initializing JSEncrypt");
  JS_ENCRYPT.setPublicKey(key);
  //JS_ENCRYPT.setPrivateKey(encryption_private_key);
  //console.log(JS_ENCRYPT);
})();

export const _encryptData = (data) => {  
  if (data === undefined || data === null) {
    data = "";
  }
  let encryptedData = JS_ENCRYPT.encrypt(data);
  if (encryptedData === false) {
    console.error(
      "Error occurred while encrypting data. Returning empty encrypted Text."
    );
    return JS_ENCRYPT.encrypt("");
  }
  return encryptedData;
}

export const encryptData = (data) => {
  if (data === undefined || data === null || data === "") {
    return "";
  }
  let chunkedData = _chunkString(data, MAX_LENGTH_WITHOUT_PADDING);

  let encryptedDataChunks = chunkedData.map((chunk) => {
    return _encryptData(chunk);
  });

   //console.log("Encrypted Chunk Data", encryptedDataChunks);

  let delimitedEncryptedDataString = "";
  encryptedDataChunks.forEach((encryptedChunk) => {
    delimitedEncryptedDataString += encryptedChunk + DELIMITER;
  });

   //console.log("Encrypted Chunk String", delimitedEncryptedDataString);

  return delimitedEncryptedDataString;
};

function _chunkString(str, length) {
  return str.match(new RegExp(".{1," + length + "}", "g"));
}




  